import { useQuery } from 'react-query'
import { useAuth0 } from '../../../contexts/auth0-context'
import callAPI from '../../../API/callSecureAPI'

export type AdminRoadmap = {
    _id: string
    product: string
    indication: string
    isActive?: boolean
    allowedUsersCount: number
    createdAt: string
    updatedAt: string
}

export type AdminRoadmapsResponse = {
    success: boolean
    data: {
        roadmaps: AdminRoadmap[]
        pagination: {
            page: number
            limit: number
            total: number
            totalPages: number
        }
    }
}

const FIVE_MINUTES = 1000 * 60 * 5

export const useAdminRoadmapsByOrgQuery = (orgId: string, page: number = 1, limit: number = 20) => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()

    const getRoadmapsByOrg = async () => {
        try {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })
            const response = await callAPI(
                `/api/admin/organizations/${orgId}/roadmaps?page=${page}&limit=${limit}`,
                'get',
                token
            )
            return response
        } catch (e) {
            console.error('Error fetching roadmaps:', e)
            throw e
        }
    }

    return useQuery<AdminRoadmapsResponse>(['admin', 'roadmaps', orgId, page, limit], getRoadmapsByOrg, {
        enabled: !!getTokenSilently && !!isAuthenticated && !isLoading && !!orgId,
        cacheTime: FIVE_MINUTES,
        staleTime: 30000,
        retry: 3,
        keepPreviousData: true,
    })
}
